exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field__details{padding-top:0;margin-bottom:-7px!important}", ""]);

// exports
